// extracted by mini-css-extract-plugin
module.exports = {"tellit":"tellit_tellit__G_bb_"};